import { render, staticRenderFns } from "./OPOSDebitoren.vue?vue&type=template&id=8c562e6c&"
import script from "./OPOSDebitoren.vue?vue&type=script&lang=ts&"
export * from "./OPOSDebitoren.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports